module.exports = __webpack_public_path__ + "img/tiffany-d-jackson.9eeb6030.png";